import { Link } from "react-router-dom";
import { useQuery } from "react-query";
import {
  Box,
  Breadcrumbs,
  Link as MuiLink,
  Stack,
  Typography,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

import { CircularLoading } from "@/components/CircularLoading";
import { useRequireParams } from "@/utils";
import { getOpportunity } from "@/services/opportunity";
import { CustomerRemark } from "@/features/member/pages/MemberProfilePage/CustomerRemark";

import { OpportunityFollowing } from "./OpportunityFollowing";
import { OpportunityDetail } from "./OpportunityDetail";

const QUERY_KEY = "getOpportunity";

export function OpportunityDetailPage() {
  const { opportunityId: id, saleId } = useRequireParams([
    "opportunityId",
    "saleId",
  ]);

  const { data, isFetching } = useQuery(QUERY_KEY, () => getOpportunity(id));

  return isFetching || !data ? (
    <CircularLoading height="calc(100vh - 182px)" />
  ) : (
    <Stack gap={4}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        <MuiLink component={Link} color="text.secondary" to="/sales">
          ฝ่ายขาย
        </MuiLink>
        <MuiLink
          component={Link}
          color="text.secondary"
          to={`/sales/${saleId}`}
        >
          ข้อมูลฝ่ายขาย
        </MuiLink>
        <MuiLink
          component={Link}
          color="text.secondary"
          to={`/sales/${saleId}/opportunities`}
        >
          รายการเพิ่มยอดขาย
        </MuiLink>
        <Typography color="text.primary">รายละเอียดลูกค้า</Typography>
      </Breadcrumbs>
      <Box display="grid" gridTemplateColumns="2fr 1fr" gap={2}>
        <Stack gap={2}>
          <OpportunityDetail data={data} queryKey={QUERY_KEY} />
          {data.member.customerId && (
            <CustomerRemark
              data={data.member.latestRemark}
              customerId={data.member.customerId}
              queryKey={QUERY_KEY}
            />
          )}
        </Stack>
        <OpportunityFollowing data={data} queryKey={QUERY_KEY} />
      </Box>
    </Stack>
  );
}
